import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=0eb78ce0&scoped=true&"
import script from "./CustomerAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAdd.vue?vue&type=style&index=0&id=0eb78ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb78ce0",
  null
  
)

export default component.exports